var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"fz-14 yx-color-text-primary yx-pingfang-semibold verti-text-bottom"},[_c('span',{staticClass:"fz-28 verti-text-bottom"},[_vm._v(_vm._s(_vm.row.product_num))]),_vm._v("件")])])
}
var staticRenderFns = []

export { render, staticRenderFns }